import Swal from "sweetalert2"; // Add SweetAlert for notifications
import { updateCARRecord } from "./updateCARRecord";

// Update CAR status based on action
export const updateCARStatus = async (recordId, cardData, action) => {
  console.log("updateCARStatus called with:", { recordId, cardData, action });
  if (!recordId) {
    console.error("No recordId provided to updateCARStatus");
    return false;
  }

  try {
    // Determine the status based on action
    let statusToSet = "";

    if (action === "Closed") {
      statusToSet = "Total CAR Closed";
    } else if (action === "PastDue") {
      statusToSet = "Total CAR Past-Due";
    } else if (action === "Open") {
      statusToSet = "Total CAR Open";
    } else {
      // If action doesn't match predefined values, use it directly as status
      statusToSet = action;
    }

    console.log(`Setting status to: ${statusToSet}`);

    // Call updateCARRecord with the Status_Kanban field
    const result = await updateCARRecord(recordId, {
      Status_Kanban: statusToSet,
    });

    if (result) {
      return {
        ...cardData,
        status: statusToSet,
        Status_Kanban: statusToSet,
      };
    }
    return false;
  } catch (error) {
    console.error("Error updating CAR status:", error);
    Swal.fire({
      title: "Update Failed",
      text: "Failed to update CAR status. Please try again.",
      icon: "error",
      confirmButtonText: "OK",
    });
    return false;
  }
};

export default updateCARStatus;
